import IoTriggerConfig from 'eflex/models/io-trigger-config';

export default class TurckIoTriggerConfig extends IoTriggerConfig {}
